// Mock content for The Kitchen Art Co. - Journal
// NOTE: All data below is mocked (frontend-only). Can be wired to a backend later.

export const logo =
  "https://lh3.googleusercontent.com/aida/AP1WRLsrNd9ia_8jd8I36d_SDqJzIyBu9vJ38TZflnnHzd-nETywq0AtnoK2-qnzPBYudo4q3wSFX_KXirOKukcBk-xJJmfHEKQz2ob8O7Q53VXMisW8XOcqy0380rVIzg3HsHhsrybWrs4JvAV3wrnafAaS5pLCMvXa-rwOKjvtYLVunww7o81SigEMA_ThhNk-qTR_1yLo7i_f8RmgV6z55CpCMNIbesq-zhLWmrU4fvDc8DNvKeG1rvNXU6M";

export const chapters = [
  { number: "01", label: "The House", to: "/" },
  { number: "02", label: "Philosophy", to: "/our-people" },
  { number: "03", label: "Experiences", to: "/experiences" },
  { number: "04", label: "The Art", to: "/culinary" },
  { number: "05", label: "The Legacy", to: "/legacy" },
  { number: "06", label: "The Journal", to: "/journal" },
  { number: "07", label: "Begin a Conversation", to: "/contact" },
];

export const navLinks = [
  { label: "The House", to: "/", active: false },
  { label: "Philosophy", to: "/our-people", active: false },
  { label: "Experiences", to: "/experiences", active: false },
  { label: "The Art", to: "/culinary", active: false },
  { label: "Legacy", to: "/legacy", active: false },
  { label: "Journal", to: "/journal", active: false },
];

// The Journal — editable. Add new entries to `entries` (top = newest).
export const journalPage = {
  eyebrow: "The Journal · A Living Record of the House",
  heading: "Seasonal notes, written slowly.",
  intro:
    "Observations from the house — on hospitality, the table, the people behind it and the celebrations we are welcomed into. The story continues here, one note at a time.",
  categories: [
    "From the House",
    "People and Practice",
    "Celebrations and Memories",
    "Culinary Notes",
    "From the Archive",
    "Places and Journeys",
  ],
  entries: [
    {
      slug: "a-wedding-in-ibiza",
      heroImage: "/journal-ibiza-tablescape.webp",
      heroAspect: "portrait",
      date: "2026-09-22",
      category: "Places & Journeys",
      kicker: "Ibiza, Spain",
      title: "A wedding in Ibiza.",
      excerpt: "Three days on a Mediterranean island — long ivory tables beneath the tamarisk trees, and a kitchen of many nations cooking as one.",
      body: [
        "In the first days of September, we travelled to Ibiza. Over three days beginning on the 1st of September 2026, we composed a wedding on the island — a celebration carried from welcome to farewell.",
        "For the seated dinner, one long ivory table ran beneath the tamarisk and olive trees, dressed in white roses, garden dahlias and delphinium, ribbed glass and brushed-gold flatware, with the low Mediterranean sun falling through the leaves. Restraint, and a great deal of it.",
        "Behind the calm was a kitchen of many nations — our own team working shoulder to shoulder with a wonderful local Ibiza brigade, sharing a pass, a rhythm and, by the last night, the same raised hands. To be welcomed so far from home, and to cook as one, is a rare and happy thing. Our thanks to every hand on the island who made it so.",
      ],
      gallery: ["/journal-ibiza-team.webp", "/journal-ibiza-chefs.webp"],
    },
    {
      slug: "a-cocktail-evening-in-udaipur",
      heroImage: "/journal-udaipur-reception.webp",
      heroAspect: "portrait",
      date: "2026-09-21",
      category: "Places & Journeys",
      kicker: "The Oberoi, Udaipur",
      title: "A cocktail evening in Udaipur.",
      excerpt: "On the lawns of The Oberoi in Udaipur, an evening reception set against Lake Pichola — candlelight, blush blooms and the City Palace glowing across the water.",
      body: [
        "On the 21st of September 2026, we travelled to Udaipur for an evening cocktail reception on the lawns of The Oberoi, set along the still edge of Lake Pichola.",
        "Beneath a canopy of blush petals, the tables were laid in crystal candelabra, mirrored tops and gardens of pink — lisianthus, roses, magnolia and tulip — with hand-painted floral chargers and warm candlelight throughout. As dusk fell, the City Palace and the ghats lit up across the water, and the lake carried their reflection back to the guests.",
        "There is a particular quiet to Udaipur at night — water, stone and light, holding a celebration gently. It was our privilege to lay the table for it.",
      ],
      gallery: ["/journal-udaipur-lake.webp"],
    },
    {
      slug: "an-evening-at-ibrahim-kothi",
      heroImage: "/journal-kareena-ibrahim-kothi.webp",
      heroAspect: "portrait",
      date: "2026-09-19",
      category: "Celebrations and Memories",
      kicker: "Ibrahim Kothi",
      title: "An evening at Ibrahim Kothi.",
      excerpt: "It was our honour to lay the table for Mrs Kareena Kapoor Khan's birthday — a candlelit dinner at Ibrahim Kothi, written as a single, quiet menu.",
      body: [
        "Some evenings are entrusted to you, and you carry them gently. On Saturday, the 19th of September 2026, it was our privilege to host the birthday dinner of Mrs Kareena Kapoor Khan — an intimate gathering at Ibrahim Kothi, beneath candlelight and old crimson drapes.",
        "The evening was written as a single menu, plated course by course. A beetroot and orange carpaccio with goat cheese and walnut to open, then a pumpkin and truffle latte. A choice of grilled Chilean sea bass or a Cajun-crusted cottage cheese steak; roast chicken, or baked morels, fennel, artichoke and olives. Pesto gnocchi, butter-tossed asparagus and snow peas, and freshly baked bread. To close — chocolate bombs, a filter-coffee tiramisu cheesecake, and tea and coffee with almond-and-orange biscotti.",
        "We are quietly grateful to have been part of it. To be asked to feed the people you admire, on the evenings that matter most to them, is the whole reason the house exists. Happy birthday, Bebo — it was an honour.",
      ],
      gallery: ["/journal-ibrahim-kothi-menu.webp"],
    },
    {
      slug: "brides-today-the-chefs-table",
      heroImage: "/journal-brides-today-puneet.webp",
      heroAspect: "portrait",
      date: "2026-09-18",
      category: "From the House",
      kicker: "Brides Today · The Chef's Table",
      title: "The Chef's Table — our founder in Brides Today.",
      excerpt: "Brides Today sits down with Puneet Sikand for a nearly thirty-year conversation on nostalgia, novelty and the quiet art of feeding a celebration.",
      body: [
        "It is a rare thing to be asked to speak, rather than simply to serve. In its latest issue, Brides Today invited our founder, Puneet Sikand, to The Chef's Table — a long conversation on the craft of catering a wedding, and on the nearly thirty years that have carried the house here.",
        "\"Good food translates to positive energy at weddings,\" he tells the magazine. \"You can get away with bloopers here and there, but the food, coupled with the service, makes or mars everything.\" It is a sentence we have quietly built the house around.",
        "The feature traces the arc of it — from a young cook trained at The Oberoi and Hyatt Regency, hand-writing menus and carrying trays of sandwiches in a Maruti 800, to seated dinners and destination weddings across Florence, Barcelona, Milan, Phuket, Monaco and Ibiza. Along the way, the celebrations of Isha Ambani and Anand Piramal, Kareena Kapoor and Saif Ali Khan, Priyanka Chopra and Nick Jonas.",
        "What he keeps returning to is the tension the house lives inside — nostalgia for the seniors who crave a flavour that returns them to a memory, and novelty for the young couples who want a table worth photographing. A warmed mawa cake on a caramel base, finished with pulled sugar, that once made an elderly guest teary-eyed. A masala raan shredded into a panini slider. Litchis spiked with wasabi. \"The trick,\" he says, \"is to floor them with surprises.\"",
        "\"It's not just about the food — the presentation and service are intrinsic to the theatrics involved. Guests should drool in anticipation, even before the food reaches their palate.\" We are grateful to Brides Today and to Sharmi Adhikary for the telling, and quietly glad the answer, after all these years, is still the same one: thank you for making this special.",
      ],
      gallery: ["/journal-brides-today-1.webp", "/journal-brides-today-2.webp"],
    },
    {
      slug: "the-lean-mean-team-coonoor",
      heroImage: "/jf-coonoor.webp",
      date: "2026-09-16",
      category: "Places & Journeys",
      kicker: "Coonoor",
      title: "The lean, mean team that went to Coonoor.",
      excerpt: "Up into the blue hills for an intimate birthday — twenty-five guests, one house, and a table worth the climb.",
      body: [
        "Some journeys are measured not in numbers but in devotion. We carried the house up into the blue hills of Coonoor for Mrs Chennai's birthday celebration — an intimate gathering for just twenty-five.",
        "A lean, mean team, a table set among the palms and the mist, and the quiet satisfaction of an evening made complete. Been there, done that — and we would do it again tomorrow.",
      ],
    },
    {
      slug: "a-toast-in-ranthambore",
      heroImage: "/jf-ranthambore.webp",
      date: "2026-09-15",
      category: "Places & Journeys",
      kicker: "Ranthambore",
      title: "A toast in Ranthambore.",
      excerpt: "Beneath gilded candelabra and scalloped arches, a palace table laid by candlelight — and a quiet toast to the moments food makes complete.",
      body: [
        "Some evenings ask only that you set a beautiful table and then step back. In a palace at Ranthambore — gold candelabra, scalloped arches, candlelight pooling on white linen — we did exactly that.",
        "A toast, then, to the moments made complete through food. That is the whole of it: the room, the light, the people, and a table laid quietly enough to hold them all.",
      ],
      gallery: ["/jf-ranthambore-2.webp"],
    },
    {
      slug: "summer-teasers-brain-freezers",
      heroImage: "/jf-kulfi-smoke.webp",
      heroAspect: "portrait",
      date: "2026-09-14",
      category: "From the Kitchen",
      kicker: "Summer Teasers",
      title: "Summer teasers — with these brain freezers.",
      excerpt: "Kesar, paan and pistachio kulfi on the stick, rolled in rose and set adrift on a cloud of cold smoke.",
      body: [
        "When the season turns, we let the kitchen play. These are our summer teasers — kulfi set on a stick, in kesar, paan-pistachio and rose, dusted with crushed petals and slivered nuts.",
        "Served over a curl of cold smoke, they arrive at the table already a little theatrical — a brain freeze worth surrendering to.",
      ],
    },
    {
      slug: "unsung-heroes-the-pushkar-chai-walas",
      heroImage: "/jf-6622.webp",
      date: "2026-09-13",
      category: "From the House",
      kicker: "Unsung Heroes",
      title: "The unsung heroes — Pushkar's chai walas.",
      excerpt: "Every grand event rests on quiet hands; here is one pair of them, and a brass pot of chai.",
      body: [
        "Every grand event rests on quiet, unseen hands. Among the unsung heroes of our industry are the Pushkar chai walas — turbaned, unhurried, pouring warmth from a burnished brass pot.",
        "We name them here because a house is only as gracious as the people who carry it.",
      ],
    },
    {
      slug: "a-seated-dinner-composed",
      heroImage: "/jf-6625.webp",
      heroAspect: "portrait",
      date: "2026-09-12",
      category: "Places & Journeys",
      kicker: "City Palace, Jaipur",
      title: "A seated dinner in the City Palace — Jaipur.",
      excerpt: "Beneath the scalloped arches and crystal chandeliers of the City Palace, a table laid in full royal grandeur.",
      body: [
        "Beneath the painted arches and twin crystal chandeliers of the City Palace of Jaipur, we composed a seated dinner in the old royal manner — a single flowered table set upon a mirror-smooth floor, framed by a corridor of scalloped stone.",
        "There are rooms that ask nothing of you but restraint, and everything of you in precision. To lay a table here is to let the palace do the speaking, and simply keep time with its grandeur.",
      ],
    },
    {
      slug: "an-island-welcome-phu-quoc",
      heroImage: "/jf-6627.webp",
      date: "2026-09-11",
      category: "Places & Journeys",
      kicker: "Phu Quoc, Vietnam",
      title: "An island welcome — Phu Quoc.",
      excerpt: "Music, colour and the warmth of Vietnam, on an island at the edge of the sea.",
      body: [
        "On the island of Phu Quoc, the evening opened with music and colour — a local welcome staged under coloured light, the warmth of Vietnam meeting a celebration carried from home.",
        "Some evenings begin as theatre. Ours began as a welcome, and never quite stopped feeling like one.",
      ],
    },
    {
      slug: "at-jw-marriott-phu-quoc",
      heroImage: "/jf-6628.webp",
      imgPosition: "object-top",
      date: "2026-09-10",
      category: "Places & Journeys",
      kicker: "Phu Quoc, Vietnam",
      title: "Among chefs — the JW Marriott, Phu Quoc.",
      excerpt: "A meeting of kitchens: our team and the island's own, working shoulder to shoulder.",
      body: [
        "At the JW Marriott on Phu Quoc, our kitchen met the island's own — Chef Puneet alongside Chefs Phuc and Matt, whites pressed, notes compared, a shared language of fire and salt.",
        "The best commissions abroad are also friendships. This one fed a wedding, and made a few.",
      ],
    },
    {
      slug: "a-candlelit-beginning-papad",
      heroImage: "/jf-6629.webp",
      date: "2026-09-09",
      category: "From the Kitchen",
      kicker: "A Theatrical Beginning",
      title: "A candlelit beginning.",
      excerpt: "Even the humblest course deserves an entrance — papads, gilded, beneath a crown of candles.",
      body: [
        "Even the humblest course deserves an entrance. Here, crisp papads arrive gilded and glowing beneath a candelabra — a theatrical beginning to the buffet.",
        "Drama, used sparingly, is simply another kind of hospitality.",
      ],
    },
    {
      slug: "a-vegan-quinoa-salad-in-a-glass",
      heroImage: "/jf-6630.webp",
      date: "2026-09-08",
      category: "From the Kitchen",
      kicker: "Light & Green",
      title: "A vegan quinoa salad, in a glass.",
      excerpt: "Quinoa, herbs and jewelled vegetables, served in a glass so the eye eats first.",
      body: [
        "Quinoa tossed with herbs and jewel-bright vegetables, spooned into a glass so the eye may eat before the fork — light, clean and quietly vegan.",
        "Proof, if it were needed, that restraint can be the most generous course of all.",
      ],
    },
    {
      slug: "feta-and-black-pepper-ice-cream",
      heroImage: "/jf-6631.webp",
      date: "2026-09-07",
      category: "From the Kitchen",
      kicker: "Sweet Meets Savoury",
      title: "Feta and black-pepper ice cream, a bacon wafer.",
      excerpt: "A savoury ice cream, a crisp bacon wafer — a small provocation, beautifully behaved.",
      body: [
        "Feta and black-pepper ice cream, cool and savoury, set against the crackle of a crisp bacon wafer: a small provocation on the palate, beautifully behaved.",
        "It surprises, then convinces — which is rather the point.",
      ],
    },
    {
      slug: "the-kitchen-trying-fermentation",
      heroImage: "/jf-6633.webp",
      date: "2026-09-06",
      category: "From the Kitchen",
      kicker: "In the Lab",
      title: "The kitchen, trying fermentation.",
      excerpt: "Jars lined along the pass — the slow, living craft of fermentation, quietly under way.",
      body: [
        "A row of glass jars along the pass, each one a small experiment in time: the kitchen trying its hand at fermentation — pickles, cultures and slow, living flavour.",
        "Some of our best ideas are simply patience, given a jar and left alone.",
      ],
    },
    {
      slug: "crowning-glory-barbecued-prawns",
      heroImage: "/jf-prawns.webp",
      date: "2026-09-05",
      category: "From the Kitchen",
      kicker: "Crowning Glory",
      title: "Crowning Glory — our barbecued prawns.",
      excerpt:
        "There is something about our barbecued prawns that keeps them on the menu — and surely earns the crown.",
      body: [
        "There is something about our barbecued prawns that has kept them on our menus for years — smoked over fire, glossed and glowing, and served, quite literally, in a silver crown.",
        "Some dishes earn their place by acclaim. This one earned its crown.",
      ],
    },
    {
      slug: "oh-kolkata-you-are-magical",
      heroImage: "/jf-kolkata.webp",
      date: "2026-09-04",
      category: "Places & Journeys",
      kicker: "Kolkata",
      title: "Oh, Kolkata — you are truly magical.",
      excerpt:
        "A lavish breakfast spread beneath crystal chandeliers — copper, fruit and candlelight, the way the city likes it.",
      body: [
        "Oh, Kolkata — you are truly magical. Beneath red drapery and crystal chandeliers we laid a breakfast spread in burnished copper: fresh fruit in glass cloches, chafing dishes aglow, and the quiet grandeur the city has always understood.",
        "Some cities simply raise the occasion to meet them. This was one of those mornings.",
      ],
    },
    {
      slug: "kansa-the-healthiest-metal",
      heroImage: "/jf-kansa.webp",
      date: "2026-09-03",
      category: "Culinary Notes",
      kicker: "On the Craft",
      title: "Kansa — the healthiest metal to cook in.",
      excerpt:
        "Why we cook and serve in bronze — an Indian tradition of health and flavour, quietly upheld.",
      body: [
        "Kansa is the Indian name for bell metal — pure bronze, an ultra-superior alloy of 78% copper and 22% tin, heated together to 700 degrees. Where copper and brass react to sour food and salt, bronze does not; it is, by tradition, the healthiest metal to eat and cook in.",
        "We hold to these old truths not for nostalgia but for the table. A dish carried in Kansa keeps its character — and a house that cares about flavour cares, first, about the vessel that holds it.",
      ],
    },
    {
      slug: "balsamic-strawberry-tiramisu",
      heroImage: "/jf-tiramisu.webp",
      date: "2026-09-02",
      category: "From the Kitchen",
      kicker: "Winter Berries",
      title: "Balsamic-soaked strawberry tiramisu.",
      excerpt:
        "Tart strawberries, smooth mascarpone and a crunchy crumble strike a perfect, ecstatic harmony.",
      body: [
        "Balsamic-soaked fresh strawberry tiramisu: a spoonful of tartness from the berries against smooth, creamy mascarpone and a crunchy crumble, struck into perfect harmony.",
        "The taste is ecstatic — and it leaves you wanting more.",
      ],
    },
    {
      slug: "blue-cheese-bruschetta",
      heroImage: "/jf-bruschetta.webp",
      date: "2026-09-01",
      category: "From the Kitchen",
      kicker: "One Perfect Bite",
      title: "Blue-cheese bruschetta, pesto and mushrooms.",
      excerpt:
        "Toasted bread, herb pesto, sautéed mushrooms, blue cheese and a blistered tomato — a canapé with conviction.",
      body: [
        "Blue-cheese bruschetta: a slice of toasted bread laid with herb pesto, sautéed mushrooms, a crumble of blue cheese and a blistered cherry tomato on top.",
        "Small, considered, and full of conviction — the kind of first bite that sets the tone for everything after.",
      ],
    },
    {
      slug: "chole-bhature-at-2800-metres-kashmir",
      heroImage: "/jf-kashmir.webp",
      imgPosition: "object-top",
      date: "2026-08-30",
      category: "Places & Journeys",
      kicker: "Gulmarg",
      title: "Chole bhature, at 2,800 metres — Gulmarg.",
      excerpt:
        "A scenic valley, incessant rain, the vagaries of the weather — and a challenge we could not resist.",
      body: [
        "Two thousand eight hundred metres above the sea, in the meadow of Gulmarg, amid the vagaries of weather and incessant rain — and, of all things, chole bhature.",
        "We took the challenge, and cooked it there, on the mountain, in the wet: comfort food carried to an impossible altitude, and all the sweeter for it.",
      ],
    },
    {
      slug: "a-hotpot-that-tastes-of-home",
      heroImage: "/jf-hotpot.webp",
      date: "2026-08-29",
      category: "From the Kitchen",
      kicker: "Comfort, Travelled",
      title: "A hotpot that tastes of home.",
      excerpt:
        "The freshest vegetables, succulent meats, silky noodles and an aromatic broth — one bite, and you're home.",
      body: [
        "Wherever life takes you, our special hotpot brings the comfort of home to the table — a flavourful journey through the world in a single vessel.",
        "The freshest vegetables, succulent meats, silky noodles and an aromatic broth, folded into one cornucopia of goodness. One bite, and you're home.",
      ],
    },
    {
      slug: "crisp-pakodas-a-monsoon-ritual",
      heroImage: "/jf-pakodas.webp",
      date: "2026-08-28",
      category: "From the Kitchen",
      kicker: "Monsoon Heaven",
      title: "Crisp pakodas, a monsoon ritual.",
      excerpt:
        "A perfect assortment of pakodas and a steaming cup of chai — a match made in monsoon heaven.",
      body: [
        "A perfect assortment of crisp pakodas, laid on banana leaf with a bowl of green chutney, paired with a steaming cup of chai — a match made in monsoon heaven.",
        "As the rains pour, let this quintessential Indian delight nourish the soul and warm the heart.",
      ],
    },
    {
      slug: "cobalt-blue-from-vase-to-table",
      heroImage: "/jf-cobalt.webp",
      date: "2026-08-27",
      category: "From the House",
      kicker: "A Table in Blue",
      title: "Cobalt blue, from vase to table.",
      excerpt:
        "Blue-and-white china, cobalt glass and indigo linen along a sunlit table — a single colour, carried through.",
      body: [
        "Cobalt blue, today — blue-and-white china, indigo napkins ringed in silver, and glassware the colour of dusk, set along a sunlit wooden table dressed with white tulips and gypsophila.",
        "A single colour, carried with discipline from vase to charger, is how a table becomes a composition.",
      ],
    },
    {
      slug: "among-masters-chefs-day",
      heroImage: "/jf-chefs.webp",
      date: "2026-08-26",
      category: "From the House",
      kicker: "The People Behind It",
      title: "Among masters — Chefs' Day.",
      excerpt:
        "A moment shared with fellow chefs — the quiet fraternity behind every plate we send out.",
      body: [
        "On Chefs' Day, a moment among masters — Chef Puneet with colleagues from the Fairmont, whites pressed, toques high, and a lifetime of kitchens between them.",
        "Every plate we send out is the work of hands like these: the quiet fraternity behind the House.",
      ],
    },
    {
      slug: "smoked-salmon-creme-caviar-canape",
      heroImage: "/jf6601.webp",
      date: "2026-08-28",
      category: "From the Kitchen",
      kicker: "Book Caterings",
      title: "Smoked salmon, crème, a bead of caviar.",
      excerpt:
        "Flavour, finesse and feeling — from handcrafted mithais to curated sit-downs, every detail a stroke of culinary brilliance.",
      body: [
        "A tray of smoked-salmon canapés, each crowned with a quenelle of crème and a single bead of caviar. Let us transform your celebration into a masterpiece of flavour, finesse and feeling.",
        "From handcrafted mithais to curated sit-downs — every detail, a stroke of culinary brilliance.",
      ],
    },
    {
      slug: "when-craftsmanship-meets-fire-gnocchi-flambe",
      heroImage: "/jf6603.webp",
      date: "2026-08-27",
      category: "From the Kitchen",
      kicker: "Flavour & Flair",
      title: "When craftsmanship meets fire — gnocchi flambé.",
      excerpt:
        "Culinary craftsmanship meets the art of fire, where flavour and flair collide.",
      body: [
        "When culinary craftsmanship meets the art of fire: gnocchi flambé, tossed in a copper pan and finished in a rush of flame.",
        "Flavour and flair collide — theatre you can taste.",
      ],
    },
    {
      slug: "before-the-first-course-the-story-begins",
      heroImage: "/jf6596.webp",
      date: "2026-08-25",
      category: "From the House",
      kicker: "Experiences Reimagined",
      title: "Before the first course, the story begins.",
      excerpt:
        "A table set with intention; a mood carefully composed — an atmosphere that prepares you for what's to come.",
      body: [
        "Before the first course arrives, the story has already begun. A table set with intention, a mood carefully composed — an atmosphere that does not merely welcome you, but prepares you for what is to come.",
        "This is the part of the evening no menu lists, and the part guests remember longest.",
      ],
    },
    {
      slug: "golden-winter-squash-a-bowl-of-comfort",
      heroImage: "/jf6598.webp",
      date: "2026-08-23",
      category: "From the Kitchen",
      kicker: "Seasonal Produce",
      title: "Golden winter squash — a bowl of quiet comfort.",
      excerpt:
        "Velvety, warming, slow-cooked — where seasonal produce meets timeless technique.",
      body: [
        "Golden winter squash, slow-cooked into a bowl of quiet comfort. Velvety, warming, and thoughtfully crafted — served, fittingly, in the squash itself.",
        "This is where seasonal produce meets timeless technique: the Kitchen Art way.",
      ],
    },
    {
      slug: "first-impressions-made-edible-canapes",
      heroImage: "/jf6600.webp",
      date: "2026-08-21",
      category: "From the Kitchen",
      kicker: "The Soul of the Party",
      title: "First impressions, made edible.",
      excerpt:
        "Our canapés aren't just starters — they're conversation starters, served in one perfect bite.",
      body: [
        "First impressions matter, so we make them edible. Our canapés are not merely starters; they are conversation starters — the soul of a party, served in a single perfect bite.",
        "Begin beautifully.",
      ],
    },
    {
      slug: "layered-with-the-season-mango-avocado",
      heroImage: "/journal-food-mango.webp",
      date: "2026-08-15",
      category: "From the Kitchen",
      kicker: "A Seasonal Plate",
      title: "Layered with the season — mango over avocado.",
      excerpt:
        "Ripe mango, crushed avocado, a whisper of chilli — the season itself, kissed onto toast.",
      body: [
        "Ripe mango laid in careful folds over crushed avocado, dusted with chilli and toasted seeds, finished with a single bloom. Vibrant, indulgent, and composed the way we compose everything — to be remembered rather than merely eaten.",
        "A small plate, and a complete idea: the season, plated.",
      ],
    },
    {
      slug: "an-oyster-station-for-a-connoisseur",
      heroImage: "/journal-food-oysters.webp",
      date: "2026-08-10",
      category: "From the Kitchen",
      kicker: "A Station for the Discerning",
      title: "Delicate, briny — an oyster station.",
      excerpt:
        "For a discerning client, a dedicated oyster station — served in its truest form.",
      body: [
        "Delicate, briny, unapologetically authentic. For a discerning client we set a dedicated oyster station, each shell offered in its truest form.",
        "No embellishment, only precision — the discipline we are known for. Curators of culinary couture.",
      ],
    },
    {
      slug: "a-thali-that-unfolds-with-intention",
      heroImage: "/journal-food-thali.webp",
      date: "2026-08-05",
      category: "From the Kitchen",
      kicker: "Nina & Siddharth",
      title: "A thali that unfolds with intention.",
      excerpt:
        "Rajasthani flavours in polished silver, opening with an amuse-bouche — a gentle prelude to what follows.",
      body: [
        "For Nina and Siddharth, a celebration curated with quiet refinement: Rajasthani flavours carried to the table in polished silver, each katori a chapter of its own.",
        "The thali begins, as the best meals do, with an amuse-bouche — a small, deliberate prelude — and then unfolds, course by course, with intention.",
      ],
    },
    {
      slug: "a-fairy-tale-in-a-bubble-lisbon",
      heroImage: "/journal-lisbon.webp",
      date: "2026-07",
      category: "Places & Journeys",
      kicker: "Sintra, Portugal",
      title: "A fairy-tale in a bubble — Lisbon.",
      excerpt:
        "Three hundred guests, a golf estate in the hills of Sintra, and a wedding held inside a transparent bubble under torrential rain.",
      body: [
        "Three hundred guests, a golf estate folded into the hills of Sintra, and a week to be remembered — this was Lisbon. We set our kitchen at Penha Longa and cooked, almost without pause, from a welcome dinner through breakfasts, lunches, hi-teas and dinners, to a farewell brunch four days later.",
        "Many of the guests had travelled from Dubai, and what moved them most was not novelty but familiarity — the comfort cooking of home, served with a precision they had not expected so far from it. They came back, plate after plate.",
        "The Sangeet took a 'Maleficent' theme, all winged figures and beautiful darkness. And then the wedding itself — held inside a transparent bubble set upon the golf course, beneath torrential rain and mesmerising light. Fairy-tale is the only honest word for it.",
        "To cook through weather like that, at that scale, in a country not your own, is to run on clockwork and nerve. We did — and the evening glittered as though the rain had been invited.",
      ],
    },
    {
      slug: "a-wedding-carried-across-the-water-venice",
      heroImage: "/journal-venice.webp",
      date: "2026-06",
      category: "Places & Journeys",
      kicker: "Venice, 2015",
      title: "A wedding carried across the water — Venice.",
      excerpt:
        "In a city with no roads, everything arrives by boat — including a full Indian kitchen shipped from home.",
      body: [
        "Venice — the floating city of water, masks and bridges — is, for all its beauty, the most difficult stage a kitchen can be asked to command. There are no service lanes here, no back doors; only canals, and the patience of a boat. Everything that arrives, arrives by water.",
        "The wedding was set on the island of St. Clemente — its palazzo and the newly built hotel across the lagoon. Our equipment travelled from India inside a single container: the tandoors, the kadhais, the patilas, even the dosa plates. For the final stretch to the island it was carried by boat and lifted ashore by a forklift that itself stood upon a barge.",
        "Our team was divided between two hotels, serving breakfast, lunch and dinner to guests who never once suspected the logistics beneath the calm. Cooks and captains caught water taxis at every hour of the day and night, crossing the lagoon with trays and timings held steady against the tide.",
        "Of all the celebrations we have carried across Europe, Venice remains the most nerve-racking — and, in memory, the most beautiful. To feed a wedding in a city with no roads is to learn, once more, that hospitality is chiefly a matter of will.",
      ],
    },
    {
      slug: "the-island-supplied-by-sea-ibiza",
      heroImage: "/journal-ibiza.webp",
      date: "2026-05",
      category: "Places & Journeys",
      kicker: "Ibiza, Spain",
      title: "The island that had to be supplied by sea — Ibiza.",
      excerpt:
        "The island that has everything had almost nothing we needed — so London became our pantry and the sea our supply line.",
      body: [
        "Meera and Prashant wanted their wedding on Ibiza — the Balearic island the world knows for its nights. We began six months out, with recce after recce, because the island that has everything had almost nothing we needed.",
        "There were no suppliers for Indian produce, so London became our pantry: groceries crossed to Barcelona and came on by cargo ship. Even the pots and pans travelled — sourced in Mumbai, shipped two months ahead, arriving at the very nick of time. An industrial township was restructured into our production base; they moved their own machinery to make room for our tandoors.",
        "The welcome dinner was at Lio; the wedding at the ME hotel amid flowers; the reception twenty miles away at Heart, where every dish rose to a second-floor terrace by service lift. Intermittent rain blessed the poolside lunch, and we cooked on regardless.",
        "It remains one of our proudest commissions — a menu curated for a true connoisseur, carried to an island by sea, and served as though it had always belonged there.",
      ],
    },
    {
      slug: "a-table-on-the-riviera-monaco",
      heroImage: "/journal-monaco.webp",
      date: "2026-04",
      category: "Places & Journeys",
      kicker: "Monaco",
      title: "A table on the Riviera — Monaco.",
      excerpt:
        "On a sliver of coast between the mountains and the sea, an evening is expected to feel effortless.",
      body: [
        "Monaco is barely a country at all — a sliver of the French Riviera, the second smallest state in the world and the most densely populated, pressed between the mountains and the Mediterranean.",
        "Its mild climate, its village charm and its glittering harbour have long made it a playground for the rich and the famous; a place of yachts and quiet fortunes, where an evening is simply expected to be effortless.",
        "To cook here is to meet a certain standard of ease. The Riviera asks for lightness — sea air, long dusks, food that flatters the setting rather than competing with it, service that moves like the tide and is noticed just as little.",
        "We came, as we always do, with our own hands and our own discipline, and left the impression we prefer to leave: that the evening had simply happened, gracefully, as though the sea itself had arranged it.",
      ],
    },
    {
      slug: "hospitality-begins-before-arrival",
      heroImage: "/table-setting-poster.jpg",
      date: "2026-03",
      category: "From the House",
      kicker: "Notes for the Wedding Season",
      title: "Hospitality begins long before a guest arrives.",
      excerpt:
        "The most important hours of a celebration are the ones no guest ever sees — the quiet afternoon before the first welcome.",
      body: [
        "The most important hours of a celebration are the ones no guest ever sees. Long before the first car turns into the drive, a room is already being made ready — not decorated, but composed. Chairs are aligned to a line only we can see. Glasses are held to the light and set down again. The temperature of a room is adjusted for a crowd that has not yet arrived.",
        "We have always believed that ease is the most difficult thing to manufacture. A guest should never feel the machinery of an evening. They should feel only that the room was waiting for them, that a seat was theirs, that the pace of the night was set to their own breathing.",
        "This is the discipline of the afternoon before. It is unglamorous work — lists checked twice, a service rehearsed in an empty hall, a final walk through the space in silence. And yet it is here, in these unwatched hours, that hospitality is truly written.",
        "By the time the first guest crosses the threshold, the labour has already disappeared. What remains is only the welcome. That is the intention: to be felt, never noticed.",
      ],
    },
    {
      slug: "the-dishes-we-did-not-serve",
      heroImage: "/the-art.jpg",
      date: "2026-02",
      category: "Culinary Notes",
      kicker: "A Note on Restraint",
      title: "The dishes we decided not to serve.",
      excerpt:
        "Every menu we compose is shaped as much by what we leave out as by what we include.",
      body: [
        "Every menu we compose is shaped as much by what we leave out as by what we include. For each course that reaches the table, there are three that do not — dishes tasted, admired, and quietly set aside.",
        "Restraint is not the absence of ambition. It is the sharpest expression of it. A table crowded with brilliance asks the guest to work; a table composed with restraint lets them simply enjoy. The art is in knowing when a menu has said enough.",
        "We test far more than we will ever plate. We cook the idea fully, we live with it, and then we ask the only question that matters: does this belong to the story of the evening, or only to our own pride? If it is the latter, it does not travel to the table.",
        "The dishes we decided not to serve are, in their way, as important as those we did. They are the silence that lets the rest be heard.",
      ],
    },
    {
      slug: "an-anniversary-in-one-gesture",
      heroImage: "/gal-wed-ballroom-dome.webp",
      date: "2026-01",
      category: "Celebrations and Memories",
      kicker: "What Was Remembered",
      title: "An anniversary, told in one gesture.",
      excerpt:
        "Fifty years of marriage, one hundred guests, and the detail nobody planned for — a song.",
      body: [
        "Fifty years of marriage, one hundred guests, and a menu built over many quiet conversations with the family. We had planned every course, every light, every pause. And yet the moment everyone would carry home was the one nobody planned for.",
        "Midway through the evening, a grandson rose without announcement and began to sing — a song the couple had danced to half a century earlier. The service stopped. Plates waited. For three minutes the room held its breath, and then it did not, and there were tears in a great many eyes.",
        "We often say that we do not cater events; we hold space for memory. That night proved it. Our work was to build a room steady enough, warm enough, unhurried enough, that such a moment could arrive on its own and be met.",
        "An anniversary of fifty years, told in one gesture. We had prepared for everything except the thing that mattered most — and preparing the ground for it was, in the end, the whole of our craft.",
      ],
    },
  ],
};

export const experiencesContent = {
  chapter: "",
  title: "Creating Experiences Beyond Catering",
  heroSubtitle:
    "We believe in stories, not service packages. Every gathering is a profound narrative waiting to be articulated through culinary craftsmanship and meticulous artistry.",
  caption: "Creating Experiences Beyond Catering",
  sections: [
    {
      eyebrow: "The Union",
      title: "Weddings",
      body: "A union of families demands a culinary experience that respects legacy while celebrating new beginnings. Our approach to weddings is honestly personal, crafting menus that reflect the couple's journey, heritage, and shared tastes. We design not just meals, but defining moments of hospitality.",
      cta: "View the Archival Gallery",
      image: "https://images.unsplash.com/photo-1627385119158-9be107951056",
      video: "/weddings-film.mp4",
      poster: "/weddings-cover.jpg",
      overlay: "The Intimate Affair",
      align: "right",
    },
    {
      eyebrow: "Heritage",
      title: "Cultural Occasions",
      body: "Honouring heritage through gastronomy requires profound respect and deep knowledge. We curate experiences that pay homage to reverential traditions, meticulously sourcing authentic ingredients and employing age-old techniques to render every dish resonant with cultural authenticity and faithful warmth.",
      cta: "Explore Our Craft",
      image: "/gal-cul-thali.webp",
      align: "left",
    },
  ],
  intimate: {
    title: "Intimate Gatherings",
    subtitle:
      "For those rare occasions meant only for the closest confidants, we design intentional, multi-course tasting menus that transform private residences or secluded venues into exclusive dining sanctuaries.",
    cards: [
      {
        eyebrow: "The Prelude",
        title: "Bespoke Canapés",
        note: "Miniature, meticulous-designed to present the palate with intense sensations.",
        image: "https://images.unsplash.com/photo-1663530761401-15eefb544889",
      },
      {
        eyebrow: "The Finale",
        title: "Architectural Desserts",
        note: "Concluding each evening with reveries composition that linger in memory.",
        image: "https://images.unsplash.com/photo-1709037331487-4ed2a6cc4b4a",
      },
    ],
  },
  cta: {
    title: "Begin the Dialogue",
    button: "Let Your Story Begin",
  },
};

export const hero = {
  chapter: "",
  title: "The Journal",
  intro:
    "A living record of the house. Reflections on craft, seasonal ingredients, and the continuing legacy of our culinary philosophy.",
};

export const mainFeature = {
  eyebrow: "Founder's Reflections",
  title: "The Pursuit of Imperfection",
  excerpt:
    "In our relentless pursuit of perfection, we often overlook the beauty found in nature's irregularities. A reflection on sourcing heirloom tomatoes.",
  image:
    "https://images.pexels.com/photos/13878326/pexels-photo-13878326.jpeg",
  alt: "A meticulously plated high-end dessert featuring delicate spun sugar and fresh seasonal berries on pristine white porcelain.",
};

export const sidebarFeatures = [
  {
    eyebrow: "Culinary Notes",
    title: "Spring Foraging: Wild Garlic",
    excerpt: "Exploring the woodland edges for this ephemeral spring delicacy.",
    image:
      "https://images.unsplash.com/photo-1572715376701-98568319fd0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxjaGVmJTIwcGxhdGluZ3xlbnwwfHx8fDE3ODY3OTEwMzB8MA&ixlib=rb-4.1.0&q=85",
    alt: "Close up of a chef's hands carefully arranging delicate microgreens onto a savory tart in a bright professional kitchen.",
    ratio: "aspect-square",
  },
  {
    eyebrow: "From the Archive",
    title: "Menu No. 04 \u2014 Autumn 2018",
    excerpt:
      "Revisiting a pivotal tasting menu that defined our approach to root vegetables.",
    image:
      "https://images.unsplash.com/photo-1711570810963-2a1554410c2b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHx2aW50YWdlJTIwcmVjaXBlJTIwYm9va3xlbnwwfHx8fDE3ODY3OTEwMzB8MA&ixlib=rb-4.1.0&q=85",
    alt: "An open vintage leather-bound ledger with elegant handwritten notes and dish sketches on an ivory wooden table.",
    ratio: "aspect-video",
  },
];

export const milestones = {
  year: "2027",
  heading: "Milestones",
  subheading: "Progressing in time \u2014 2027.",
  entries: [
    {
      date: "September 2027",
      title: "The New Atelier",
      body: "Opening the doors to our dedicated test kitchen and fermentation lab, expanding our capacity for culinary research.",
    },
    {
      date: "March 2027",
      title: "Spring Equinox Gathering",
      body: "Our inaugural collaborative dinner featuring guest chefs from London & UAE, celebrating the turn of the season.",
    },
  ],
};

export const footerLinks = [
  { label: "Press Kit", href: "/press-kit" },
  { label: "Contact", href: "/contact" },
];

export const pressKitContent = {
  eyebrow: "For the Press",
  heading: "Press Kit",
  intro:
    "A quiet record of who we are, for those who wish to write about us. Everything here may be used with attribution; for interviews, imagery in higher resolution, or specific requests, please reach the house directly.",
  facts: [
    { label: "Founded", value: "1997" },
    { label: "House", value: "The Kitchen Art Co." },
    { label: "Discipline", value: "Catering & Hospitality" },
    { label: "Reach", value: "Pan-India & Abroad" },
  ],
  about:
    "The Kitchen Art Co. is a hospitality house that has quietly shaped weddings, state banquets and private celebrations for nearly three decades. Our work is defined less by spectacle than by restraint — the belief that the finest hospitality is felt, not announced.",
  boilerplate:
    "Since 1997, The Kitchen Art Co. has served as a private catering and hospitality house, entrusted with occasions across India and abroad. Guided by an understated philosophy — 'Not to be noticed. To be remembered.' — the house is known for its considered menus, cinematic tablescapes and a team that treats every gathering as its own.",
  assets: [
    { title: "The Wordmark", note: "Primary logotype, for editorial use.", image: "/gal-cul-thali.webp" },
    { title: "Signature Tablescape", note: "The Grazing Table, in portrait.", image: "/gal-wed-grazing.webp" },
    { title: "The House at Work", note: "The art of live fire.", image: "/legacy-beginning-chef.webp" },
  ],
  contactLabel: "Media Enquiries",
  contactNote: "For press and partnership requests, please write to us.",
};

export const legacyContent = {
  chapter: "",
  title: "A House Built Over Time",
  heroSubtitle: "Creating Experiences Beyond Catering",
  intro:
    "Our journey is not measured in years, but in the indelible marks left upon the tables we have graced. We are an archival institution of taste, recording three decades of quiet elegance, meticulous craft, and the enduring legacy of hospitality.",
  images: {
    stonePath:
      "/legacy-beginning-chef.webp",
    diningTable:
      "/legacy-plates.webp",
    ledger:
      "/team-collective.webp",
    motogp:
      "https://lh3.googleusercontent.com/aida-public/AB6AXuAUtxnJUbSdBiAvJ3AUq3U8yty3FN98Mw00Lm4jZ4EkQQ5GXWZJHs_JhckBB1nWqGx9Km8TWEXYD_hmvcsDlSfe3FBHXWlmKRw2yiDNN73wodY2noqR0B1xu2NV_0MdHwHjouoRINTg5ISq3HUlfqPDOeZvdVAeJPft3YU70oaN3uJ9itjp5_HqP7raa1U6M6gHd3Gyjl7_VRu--ozq9aC5gi25HdQ7Fnu-iSoP4SVQ-LHuGM5-Gwg4CBHjekly1MfH7w",
    istanbul1:
      "https://lh3.googleusercontent.com/aida-public/AB6AXuBD0aSKgzesdWfnKujFHAEFOGpX1MuNVB_MNspqL1rywINMAAt12vLm2gocY9ziV9_A3CsViAXZLPFR5Msao3HYooRdUlLubYFFMm8b2wFSnWEch-xNx841kKN_aEhqBK2EzPXbZUC8y0D1sYdrP0bosvmmz5lOXrGFqQ_QboGN6G1Hjev1qPY2HW_WsJHCdOOlAJtqWu13SF0WXK_ubsNShvM78prDN20BhKFJ2SW_0_9wTtYKVd_8L9oM3F5Zdfrmgg",
    istanbul3:
      "https://lh3.googleusercontent.com/aida-public/AB6AXuChkWAF-0IvYdYLyUd7xkvtc2VWA3s3VSVs_V0qYovtv4MbMk1OT2Z_MnxIOaQ5LImrGczZ2Gsln4QY208yTaXQdgr90lEVBC3L6JtQeeXWE-PceMmEkhe1kU9ivNqvQJNpYFtHkmLFNFn4B2cKV6F0WvMFdBzM_yk4y37I-0U8fK0JUow8JQ1e03Trpk5xOA7N0Wqc9IalsfFrGTAGH7NmHZylazSB3gdOEdXLDJa3PuykrnV332QkfxQ564hkH72SEQ",
    monaco1:
      "https://lh3.googleusercontent.com/aida-public/AB6AXuAlpUpqjYImLli9eMNeMOpudSogqeOMdMg-T6W4Lfil8riG1RuN2soWtouvgaHTGlDr0mNq6IVj2oW0H6EJ9Z4yhS_uL6tPedSa7nF7qsSTHdkwgvl2uMOHcg2wmH6k8ywko1CnGAWOF-lyqg1YD85SdrCUtasFg1v-_3a1Cbaawt8URxScHoRySNXOHMO7Azi3vcPAOQVaTKl3NQnWxsw_sKJRHVQDMK_Ai_XXQPn_pWvR7QuHtlbI-4vKZK41GyA7qw",
    monaco2:
      "https://lh3.googleusercontent.com/aida-public/AB6AXuCr63hL2SSpx8SkmyDwdk5vByHKDpkpID3FH-7079I3wyKk_fdW9KNhrdvWXlM1w15Hl-1rZIFsDuu9viELvAzwwpcJ3Q_f5N5Rzw-uucDX2UV5jvcPEWtIUqpDpLvYdM9pGYxhNSd7GtA8jUbRQw3vxGkrX3I7-CWYSBQsZqwDymovEO9qIa6aMQHZImXzut4orhLTg7kuVVrN_FesoId_CYpsqVb2L8AsNF8pqR6j5ZSRYRFu6bq9Sw_duJbtTmBi4Q",
  },
  eras: [
    {
      label: "1997",
      title: "The Beginning",
      body: "It started with a singular vision: to elevate the act of dining from mere sustenance to an art form. In the quiet corners of our first kitchen, the foundational principles of restraint, respect for ingredients, and uncompromising standards were codified.",
    },
    {
      label: "The Formative Years",
      title: "Learning Through Service",
      body: "True luxury whispers. We learned that the spaces between courses, the silent anticipation, and the seamless choreography of service were just as critical as the culinary execution itself. It was an era of rigorous refinement.",
    },
    {
      label: "The Collective",
      title: "Building the Team",
      body: "A house is only as strong as its foundation. We gathered artisans, purveyors, and visionaries who shared our quiet devotion to the craft. Together, we built a lineage of excellence that transcends any single individual.",
    },
    {
      label: "Present Era",
      title: "Today & The Future",
      body: "We remain custodians of a timeless philosophy. While techniques evolve and palates shift, our commitment to creating profound, enduring memories remains absolute. We look forward, grounded by the weight of our history.",
    },
  ],
  sealBand: {
    caption: "30 Years of Leaving Food-Prints",
    progress: "Progressing in time — 2027",
  },
  foodprints: {
    eyebrow: "Global Food-Prints",
    heading: "Milestones",
    worldMapImage:
      "https://upload.wikimedia.org/wikipedia/commons/b/b6/World_location_map_%28equirectangular_180%29.svg",
    milestones: [
      { city: "Antalya, Turkey", event: "Maruti Suzuki Dealer Conference", x: 58.5, y: 29.5 },
      { city: "Barcelona, Spain", event: "Hero MotoCorp Conference", x: 50.6, y: 27.0 },
      { city: "Greater Noida, India", event: "MotoGP International Event", x: 71.5, y: 34.2 },
      { city: "Istanbul, Turkey", event: "International Culinary Event 2023", x: 58.1, y: 27.2 },
      { city: "Monaco", event: "Private Destination Wedding", x: 52.1, y: 25.7 },
      { city: "Malaysia", event: "Private Destination Wedding" },
      { city: "Ibiza", event: "Private Island Celebration" },
      { city: "Mauritius", event: "Private Destination Wedding" },
      { city: "Muscat", event: "Private Destination Wedding" },
      { city: "Abu Dhabi", event: "Private Destination Wedding" },
      { city: "Switzerland", event: "Private Destination Wedding" },
      { city: "Venice", event: "Private Destination Wedding" },
      { city: "Austria", event: "Private Destination Wedding" },
      { city: "Venice", event: "Private Destination Wedding" },
      { city: "Vienna", event: "Private Destination Wedding" },
      { city: "Salzburg", event: "Private Destination Wedding" },
      { city: "Montreux", event: "Private Destination Wedding" },
      { city: "Kota Kinabalu", event: "Private Destination Wedding" },
      { city: "Hua Hin", event: "Private Destination Wedding" },
      { city: "Phuket", event: "Private Destination Wedding" },
      { city: "Florence", event: "Private Destination Wedding" },
      { city: "Lisbon", event: "Private Destination Wedding" },
      { city: "Cannes", event: "Private Destination Wedding" },
      { city: "New Delhi", event: "State Banquet & Diplomatic Reception" },
      { city: "Mumbai", event: "Private Sea-Facing Wedding" },
      { city: "Kolkata", event: "Heritage Family Celebration" },
      { city: "Bengaluru", event: "Private Garden Reception" },
      { city: "Hyderabad", event: "Grand Wedding Banquet" },
      { city: "Jaipur", event: "Royal Fort Wedding" },
      { city: "Udaipur", event: "Lakeside Destination Wedding" },
      { city: "Ahmedabad", event: "Grand Family Wedding" },
      { city: "Goa", event: "Beachfront Celebration" },
      { city: "Lucknow", event: "Nawabi Feast & Reception" },
      { city: "Amritsar", event: "Private Family Gathering" },
      { city: "Kochi", event: "Backwater Destination Wedding" },
      { city: "Chandigarh", event: "Private Estate Wedding" },
      { city: "Pune", event: "Corporate Conference Catering" },
      { city: "Srinagar", event: "Valley Destination Wedding" },
      { city: "Bhubaneswar", event: "Temple-City Celebration" },
      { city: "Indore", event: "Grand Reception Banquet" },
      { city: "Ludhiana", event: "Private Family Wedding" },
      { city: "Raipur", event: "Grand Reception Banquet" },
      { city: "Bareilly", event: "Private Family Gathering" },
      { city: "Mahabaleshwar", event: "Hillside Destination Wedding" },
      { city: "Agra", event: "Heritage Destination Wedding" },
      { city: "Surat", event: "Grand Family Wedding" },
      { city: "Baroda", event: "Palace Wedding Reception" },
      { city: "Coonoor", event: "Hill-Station Birthday Celebration" },
      { city: "Beawar", event: "Private Family Celebration" },
      { city: "Ajmer", event: "Royal Reception Banquet" },
      { city: "Gulmarg", event: "Snow-Valley Destination Wedding" },
      { city: "Mussoorie", event: "Hill-Station Destination Wedding" },
      { city: "Dehradun", event: "Valley Estate Celebration" },
      { city: "Budapest", event: "Private Destination Wedding" },
      { city: "Jaisalmer", event: "Desert Fort Destination Wedding" },
      { city: "Ranthambore", event: "Palace Celebration Dinner" },
      { city: "Phu Quoc, Vietnam", event: "Private Island Destination Wedding" },
    ],
  },
  appreciation: {
    eyebrow: "Testaments of Appreciation",
    quote:
      "A few quiet words, kept for decades. Exceptional contribution to hospitality and a profound catalyst for conversation.",
  },
};

export const houseContent = {
  hero: {
    chapter: "",
    title: "Welcome to the House",
    image:
      "https://images.unsplash.com/photo-1778209816989-6b6aa0d7e7c3",
    body: "The Kitchen Art Co. is not merely a catering service; it is an institution dedicated to the preservation and elevation of hospitality. Founded on principles that predate modern convenience, our House operates as a silent partner in life's most significant milestones. We believe that true luxury is whispered, felt in the weight of a heavy linen napkin, the perfect temperature of a vintage, and the seamless orchestration of an event where the effort remains invisible. Our narrative is woven through the countless private celebrations and diplomatic gatherings we have quietly overseen.",
  },
  whoWeAre: {
    chapter: "",
    title: "Who We Are",
    body: "We are a collective of artisans, logisticians, and visionaries. Our House is built on the unwavering belief that hospitality is a rigorous discipline disguised as an effortless art form. Every menu is an archive of flavours, meticulously catalogued and executed with precision.",
    image:
      "https://images.unsplash.com/photo-1541508159146-2ab9c877e804?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  hospitality: {
    title: "A House Built on Hospitality",
    body: "Logistics and design are the hidden foundations of our House. Before the first course is served, an architectural approach to planning ensures that the aesthetic and functional aspects of an event are in perfect harmony. We construct experiences that endure in memory long after the evening concludes.",
  },
  founder: {
    eyebrow: "Founder's Voice",
    quote:
      "The art of hospitality lies in anticipating a need before it is voiced, and answering it with grace.",
    attribution: "From the Archives, 1998",
    image:
      "https://images.unsplash.com/photo-1701721865389-9935778b40e3",
  },
  recognition: {
    eyebrow: "Relationships & Recognition",
    items: [
      { title: "Corporate Diplomacy Partner", detail: "G20 Summit, New Delhi" },
      { title: "Preferred Hospitality House", detail: "Umaid Bhawan Palace" },
      { title: "Architects of Fine Dining", detail: "Vogue India Celebrations" },
    ],
  },
};

export const culinaryContent = {
  chapter: "",
  title: "The Art",
  heroSubtitle: "From Sketch to Service",
  heroImage: "/the-art.jpg",
  intro: {
    eyebrow: "The Discipline of Taste",
    body: "Every dish begins as a drawing. Before a single ingredient is sourced, our chefs compose on paper — mapping form, texture, and tension. What arrives at the table is the faithful execution of an idea first sketched in the quiet of the atelier.",
  },
  dishes: [
    {
      numeral: "I",
      name: "Prawn Satay, Raw Papaya Salad",
      note: "A whole prawn satay — head and tail intact — lacquered with rich peanut sauce and crowned with a small tangle of Thai raw papaya salad.",
      image: "/som-tam.png",
    },
    {
      numeral: "II",
      name: "Pepper Rasam Cannoli",
      note: "A crisp cannoli stuffed with spiced potato, plated over glossy sambhar gel and finished with a scattering of deep-red rasam caviar.",
      image: "/rasam-cannoli.png",
    },
    {
      numeral: "III",
      name: "Guava Chaat, Crisp Enoki",
      note: "A base of precisely cut guava crowned with a delicate structure of fried enoki — a study in contrasting textures and quiet drama.",
      image: "/guava-chaat.jpg",
    },
  ],
  sitDown: {
    eyebrow: "Sit-Down Protocol",
    heading: "Plated, paced and personal.",
    body: "Individually composed courses, brought to the table with the quiet choreography of a private dining room.",
    items: [
      {
        name: "Grilled Jaipur Goat Chops",
        note: "Rosemary-smoked goat chops, chargrilled over embers and glazed in their own rendered juices, with roasted garlic and whipped butter.",
        image: "/goat-chops.webp",
        aspect: "aspect-[4/3]",
      },
      {
        name: "Berry Tartlets",
        note: "Buttery and dark-chocolate shells filled with silken curd and crowned with blackberry, redcurrant, blueberry and a sprig of mint.",
        image: "/sit-berry-tartlets.webp",
        aspect: "aspect-[4/3]",
      },
      {
        name: "Glazed Prawns, Crisp Lime Leaf",
        note: "Plump prawns lacquered in a dark, glossy reduction, strewn with fried lime leaf and finished with edible blossoms — sweet, savoury and delicate at once.",
        image: "/plated-prawns.webp",
        aspect: "aspect-[4/3]",
      },
      {
        name: "Miso Eggplant",
        note: "Charred eggplant skewers glazed in white miso, finished with sesame and spring onion.",
        image: "/sit-tofu-skewers.webp",
        aspect: "aspect-[4/3]",
      },
      {
        name: "Braised Shiitake",
        note: "Meaty shiitake caps baked with molten cheese, blistered cherry tomatoes and torn basil in a warm, golden broth.",
        image: "/sit-shiitake.webp",
        aspect: "aspect-[4/3]",
      },
      {
        name: "Cous Cous Pilaf",
        note: "Saffron couscous tumbled with roasted vegetables, chickpeas, charred lime and fresh mint.",
        image: "/sit-couscous-pilaf.webp",
        aspect: "aspect-[4/3]",
      },
    ],
  },
  vegRepertoire: {
    eyebrow: "The Vegetarian Repertoire",
    heading: "Earth, treated with reverence.",
    body: "Vegetables given the gravity of prime cuts — layered, lacquered and coaxed to their fullest expression.",
    items: [
      {
        name: "Tacos, with an Indian Accent",
        note: "Soft, herb-green flatbread folded taco-style around ribboned peppers, red cabbage, cucumber and quinoa, brightened with fresh mint — the street taco reimagined with an Indian heart.",
        image: "/veg-green-pita.webp",
        aspect: "aspect-[4/5]",
      },
      {
        name: "Focaccia di Recco",
        note: "Whisper-thin Ligurian focaccia baked on volcanic stone and folded around molten young cheese — crisp, buttery and barely there.",
        image: "/veg-c.webp",
        aspect: "aspect-[4/5]",
      },
      {
        name: "Harissa Butternut Squash",
        note: "Fanned butternut squash lacquered in rose harissa over whipped labneh, crisped sage, toasted walnuts and a thread of chilli oil.",
        image: "/veg-b-cw.webp",
        aspect: "aspect-[4/5]",
      },
      {
        name: "Vegan Ramen",
        note: "A clear, slow-drawn mushroom broth with buckwheat noodles, charred bok choy, enoki and a lace of chilli and toasted sesame.",
        image: "/veg-ramen.webp",
        aspect: "aspect-[4/5]",
      },
      {
        name: "Mango Salad, Mustard Seed & Curry Leaf",
        note: "Ripe mango tossed with tempered black mustard seed and fresh curry leaf — sweet, sharp and fragrant.",
        image: "/veg-saffron.webp",
        aspect: "aspect-[4/5]",
      },
    ],
  },
  nonVegRepertoire: {
    eyebrow: "The Non-Vegetarian Ledger",
    heading: "Fire, spice and the long braise.",
    body: "From the tandoor to the coastal kadhai — proteins handled with patience, heat and a deep respect for provenance.",
    items: [
      {
        name: "Lamb Shank Biryani",
        note: "Slow-braised lamb shank buried in saffron basmati, sealed and dum-cooked with fried onion, almond and a whisper of kewra.",
        image: "/lamb-biryani.webp",
        aspect: "aspect-[4/5]",
      },
      {
        name: "Thai Prawn Curry",
        note: "Tiger prawns simmered in a fragrant Thai red coconut curry, lifted with lemongrass, kaffir lime, bird's-eye chilli and Thai basil.",
        image: "/prawn-curry.webp",
        aspect: "aspect-[4/5]",
      },
      {
        name: "Raw Mango Fish Curry",
        note: "Coastal fish simmered in coconut and green raw mango, gently soured and spiced, finished with curry leaf and a slick of coconut oil.",
        image: "/raw-mango-curry.webp",
        aspect: "aspect-[4/5]",
      },
      {
        name: "Seafood Paella",
        note: "Saffron bomba rice slow-simmered in shellfish stock, crowned with prawns, clams and mussels and finished with a scatter of fresh chive.",
        image: "/seafood-paella.webp",
        aspect: "aspect-[4/5]",
      },
    ],
  },
  closing: {
    quote:
      "We do not plate food. We plate the memory of an idea, executed with precision.",
    attribution: "From the Atelier",
  },
  menuHeading: "The Chapters",
  menuChapters: [
    {
      eyebrow: "Botanical Focus",
      eyebrowColor: "text-veg-green",
      title: "The Vegetarian Repertoire",
      body: "Elevating earth's provisions through classical technique. Root vegetables treated with the reverence of prime cuts, and delicate herbs woven into complex broths.",
      cta: "Explore Selection",
    },
    {
      eyebrow: "Heritage Cuts",
      eyebrowColor: "text-brand-secondary",
      title: "The Non-Vegetarian Ledger",
      body: "Sourced with provenance and prepared with restraint. Slow-braised meats, precisely aged fowl, and marinades that whisper of centuries-old trade routes.",
      cta: "Explore Selection",
    },
    {
      eyebrow: "The Theater",
      eyebrowColor: "text-muted-taupe",
      title: "Sit-Down Protocol",
      body: "The choreography of formal service. A silent ballet of silver and porcelain, where pacing is as crucial as the seasoning, ensuring a seamless narrative flow.",
      cta: "View Protocols",
    },
  ],
};

export const contactContent = {
  eyebrow: "Let the Conversation Begin",
  openingQuote: "Every celebration ends. The memories should not.",
  title: "Every celebration ends. The memories should not.",
  subtitle:
    "If you are planning a celebration that deserves thoughtful hospitality, refined cuisine and uncompromising attention to detail, we would be honoured to become part of your story.",
  formHeading: "The Threshold",
  fields: {
    name: "Your Name",
    email: "Email",
    phone: "Phone",
    occasion: "Occasion",
    date: "Preferred Date",
    guests: "Guests",
    message: "Which cuisines do you prefer?",
  },
  placeholders: {
    name: "Full name",
    email: "you@email.com",
    phone: "Optional",
    date: "Approximate is fine",
    guests: "Estimated number",
    message: "Tell us about the celebration you envision",
  },
  occasions: [
    "A Wedding",
    "A Private Celebration",
    "A Corporate Gathering",
    "A Diplomatic Occasion",
    "A Cultural Event",
    "Something Else",
  ],
  button: "Send Enquiry",
  house: {
    heading: "The House",
    correspondence: {
      label: "Correspondence",
      phone: "+91 97170 93533 / 34 / 35",
      email: "tkac@tkac.in",
      whatsapp: "WhatsApp the house",
      handle: "@thekitchenartco",
    },
    sanctuary: {
      label: "Sanctuary",
      button: "Our House",
      address:
        "The Kitchen Art Company, Ratiya Pradhan Rd, Jonapur, Mehrauli, New Delhi 110047",
      mapQuery:
        "The Kitchen Art Company, Ratiya Pradhan Rd, Jonapur, Mehrauli, New Delhi 110047",
    },
  },
  closingQuote: "What would you like your guests to remember?",
  footerTagline: "30 Years of Leaving Food-Prints — Progressing in Time",
};

export const ourPeopleContent = {
  founder: {
    portrait: "/founder.png",
    name: "Puneet Sikand",
    role: "Founder & Director",
    title: "A Life Devoted to Hospitality",
    letter: [
      "The Kitchen Art Co. was never created to be the largest. It was created to become the most thoughtful.",
      "My belief remains simple: people rarely remember every dish served, but they always remember how a celebration made them feel. This conviction has guided every decision since 1997.",
      "True luxury is found in restraint, sincerity, and an uncompromising attention to detail. In an industry that constantly reinvents itself, we have stayed true to ourselves. We have not pursued trends. We have pursued timelessness.",
      "Today, the House is a reflection of these values—warmth, integrity, and the belief that elegance is not about being noticed. It is about being remembered.",
    ],
  },
  people: {
    eyebrow: "People and Practice · Our Greatest Strength",
    quote:
      "Our greatest strength is not our kitchen, our vehicles or our inventory. It is our people.",
    body: "Behind every experience stand chefs, captains, stewards and managers — many of whom have been with the house for decades — and a next generation learning the same quiet discipline. Guests may never learn their names, but they will always remember their care.",
    roles: [
      { title: "The Chefs", detail: "Masters of world cuisine, rooted in Indian intelligence." },
      { title: "The Captains", detail: "The quiet choreography of every evening, rehearsed to invisibility." },
      { title: "The Stewards", detail: "Care that no guest is meant to notice — only to feel." },
      { title: "The Managers", detail: "Decades with the house, holding every detail to its standard." },
    ],
  },
  honours: {
    eyebrow: "Honours · A Quiet Row",
    items: [
      { source: "The Times of India · 2020", title: "Times Hospitality Icons", detail: "Iconic Luxury Catering Company, Delhi/NCR" },
      { source: "The Economic Times · 2024", title: "ET Wedding Leaders", detail: "Excellence in Catering for Destination Weddings" },
      { source: "Indian Culinary Forum · 2023", title: "International Chef Awards", detail: "Outstanding Contribution to Food Service Entrepreneurship" },
      { source: "Food Food · 2023", title: "Top 50 Restaurant Awards", detail: "Exceptional Contribution to Catering" },
    ],
  },
  wall: {
    testimonials: [
      { quote: "Absolutely A+ class! The food, the service, the effort \u2014 and above all the smile of every staff member of yours was amazing. Thank you for a fabulous three days.", name: "Renuka & Rana Talwar", caption: "A Three-Day Celebration" },
      { quote: "It was indeed a pleasure associating with you. We had an excellent experience \u2014 the food was excellent and the event went very gracefully because of you and your team's effort. Hope to have a long-term association with the Kitchen Art family.", name: "Gurnam Singh Joneja", caption: "Joneja Bright Steels" },
      { quote: "The food and service was excellent at the wedding. Please pass this on to your team \u2014 they were stars!", name: "Sonali Saraogi", caption: "A Wedding Celebration" },
      { quote: "As usual, you outdid yourself. Your food was superb.", name: "Uma Gajapati", caption: "A Returning Host" },
      { quote: "Amazing, amazing food and exceptional service. I have received so many compliments on your behalf, and I am rightfully forwarding them to you.", name: "Varun Tandon", caption: "A Private Gathering" },
      { quote: "Food in the hands of creative people becomes soul-satiating and experiential. The art and skill of connecting with the guests through your flavours and aromas was genuinely witnessed at the buffet. I cannot thank you enough for the wonderful spread, as also the personalised care of our guests.", name: "Vineeta & Shashi Kant Chaurasia", caption: "KP Group · A Reception at Sudama Farms" },
    ],
    eyebrow: "The Wall of Appreciation · In Their Words",
    heading: "A few quiet words, kept for decades.",
    body: "These notes were written to the house by the families and hosts we have served — transcribed here exactly as they arrived.",
    quote:
      "Although most of our friends had participated in such kind of events earlier, none had ever experienced the type of hospitality, catering, elegance and style associated with this event. Million thanks for all you did to make it even more special. Well done and do keep it up!",
    attribution: "K.P. Singh, Chairman, DLF · New Delhi, 2014",
  },
};
